import { render, staticRenderFns } from "./workinfo.vue?vue&type=template&id=8758beac&scoped=true&"
import script from "./workinfo.vue?vue&type=script&lang=js&"
export * from "./workinfo.vue?vue&type=script&lang=js&"
import style0 from "./workinfo.vue?vue&type=style&index=0&id=8758beac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8758beac",
  null
  
)

export default component.exports